import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { stepperFeatureKey, stepperReducer } from "./state/stepper.reducer";

@NgModule({
	declarations: [],
	imports: [CommonModule, StoreModule.forFeature(stepperFeatureKey, stepperReducer)],
})
export class StepperModule {}
